const ThankYou = () => import ("./pages/ThankYou.vue");
const FeedbackPage = () => import ("./pages/FeedbackPage.vue");
const UserDetailsForm = () => import("./pages/UserDetailsForm.vue");
const TermsPage = () => import("./pages/TermsPage.vue");
const PrivacyPage = () => import("./pages/PolicyPage.vue");
const CustomQuestions = () => import("./pages/CustomQuestions.vue");
const CustomQuestions2 = () => import("./pages/CustomQuestions2.vue");
const SpriteCampaign = () => import("./pages/SpriteCampaign.vue");
const RatingPage = () => import("./pages/RatingPage.vue");



export const SpriteRoutes = [
  {
    path: '/sprite_campaign',
    component: SpriteCampaign,
    meta: {
      title: 'Sprite Thand Rakh!'
    },
    children: [
      {
        path: 'user',
        component: UserDetailsForm
      },
      {
        path:'tnc',
        component:TermsPage
      },
      {
        path:'privacy',
        component:PrivacyPage
      },
      {
        path:'quiz',
        component:CustomQuestions
      },{
        path:'ratings',
        component: RatingPage
      },
      {
        path:'feedback',
        component:FeedbackPage
      },
      {
        path:'quiz2',
        component:CustomQuestions2
      },
      {
        path:'thankyou',
        component:ThankYou
      }
    ],
  }
];
